import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/KineticLines";

export const Chapters = ({ items }) => (
  <section data-testid="services-chapters" className="py-24 md:py-36 px-5 md:px-10 max-w-7xl mx-auto">
    <Reveal className="mb-16">
      <p className="text-primary text-xs font-bold tracking-[0.3em] uppercase mb-3">What We Do</p>
      <h2 className="font-display text-5xl md:text-7xl leading-[0.9]">THE WORK,<br />CHAPTER BY CHAPTER</h2>
    </Reveal>
    <div className="space-y-6 md:space-y-8">
      {items.map((item, i) => (
        <Reveal key={item.num} delay={i * 0.08}>
          <div
            data-testid={`chapter-${item.num}`}
            className={`group grid md:grid-cols-12 gap-6 md:gap-10 items-center border border-white/15 bg-card rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.25)] p-6 md:p-10 transition-colors duration-500 hover:border-primary/40 ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
          >
            <div className="md:col-span-5 [direction:ltr] overflow-hidden rounded-xl">
              <img src={item.image} alt={item.title} loading="lazy" style={{ objectPosition: item.position || "center" }} className="w-full aspect-[4/3] object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="md:col-span-7 [direction:ltr]">
              <span className="font-display text-6xl md:text-8xl text-outline leading-none">{item.num}</span>
              <h3 className="font-display text-3xl md:text-5xl tracking-wide mt-2 mb-4 group-hover:text-primary transition-colors duration-500">{item.title}</h3>
              <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-lg">{item.text}</p>
              <div className="mt-6 flex items-center gap-2 text-primary text-xs font-bold uppercase tracking-widest opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
                Included in every free estimate <ArrowRight size={14} aria-hidden="true" />
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
